'use client';

import { styled } from '@linaria/react';
import { SCREEN_SIZE } from '@fe-common-utils/constants/screen';
import { RectangleSkeleton } from '@fe-common-ui/Skeleton';

const Container = styled.div`
  display: flex;
  column-gap: 12px;
  padding-bottom: 13px;
  border-bottom: 1px solid #e2e8f1;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  flex: 1;
`;

const SymbolWrapper = styled.div`
  align-self: center;

  @media screen and (max-width: ${SCREEN_SIZE.TABLET}px) {
    padding-top: 31px;
    padding-bottom: 12px;
  }
`;

const SubTitle = styled.div`
  display: flex;
  align-items: center;
  font-size: 13px;
  column-gap: 8px;
  letter-spacing: 0.5px;

  .dot {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: #e2e8f1;
  }

  .divide {
    width: 2px;
    height: 16px;
    padding: 1px 0px;
    background-color: #e2e8f1;
  }
`;

const TitleAndSaveButtonContainer = styled.div`
  display: flex;
  column-gap: 12px;
  align-items: center;
  justify-content: space-between;
`;

const HotCollectionCardSkeleton = () => {
  return (
    <Container>
      <SymbolWrapper>
        <RectangleSkeleton width={24} height={30} />
      </SymbolWrapper>
      <ContentContainer>
        <SubTitle>
          <RectangleSkeleton width={38} height={16} />
          <div className='dot' />
          <RectangleSkeleton width={27} height={19} />
          <div className='divide' />
          <RectangleSkeleton width={18} height={18} />
        </SubTitle>
        <TitleAndSaveButtonContainer>
          <RectangleSkeleton width={530} height={24} />
          <RectangleSkeleton width={33} height={33} />
        </TitleAndSaveButtonContainer>
      </ContentContainer>
    </Container>
  );
};

export default HotCollectionCardSkeleton;
